import { INFOBOX_VARIANT } from '@motorway/mw-highway-code/enums';
import { toast } from '@motorway/mw-highway-code/pre-alpha';

import { DocumentCaptureError } from './DocumentCaptureError';

export const displayToast = (err:unknown) => {
  const toastContent = err instanceof DocumentCaptureError
  // Document Capture error always has title and message so its directly translatable to toasts.
    ? err
    : {
      message: (err as Error)?.message || (err as {error: string})?.error || 'Something went wrong',
      title: (err as {title: string}).title || (err as Error).name || 'Error',
    };

  toast({
    content: toastContent.message,
    heading: toastContent.title,
    variant: INFOBOX_VARIANT.ERROR,
  });
};
